import { Suspense } from "react";
import { useSelector } from "react-redux";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import RootLoading from "../components/RootLoading/RootLoading";
import ScrollToTop from "../components/utils/ScrollToTop";
import Redirect from "./Redirect";
import pagesRoute from "./routes/pages";
import dashboardRoute from "./routes/dashboard";
import { IRootState } from "..";

const Router = () => {
  const user = useSelector((state: IRootState) => state.user.value);

  const { loggedIn } = user;

  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="z-[2147483019]">
        <Toaster />
      </div>
      <Suspense fallback={<RootLoading />}>
        <Routes>
          {pagesRoute.map((route) => {
            if (
              route.meta.protectedRoute &&
              route.meta.role === "user" &&
              loggedIn
            ) {
              return (
                <Route
                  key={route.path}
                  path={route.path}
                  element={<route.component />}
                >
                  {dashboardRoute.map((dRoute) => (
                    <Route
                      key={dRoute.path}
                      path={dRoute.path}
                      element={
                        <Suspense fallback={<RootLoading />}>
                          <dRoute.component />
                        </Suspense>
                      }
                    />
                  ))}
                </Route>
              );
            }
            if (route.meta.protectedRoute && !loggedIn) {
              return (
                <Route
                  key={route.path}
                  path={route.path}
                  element={<Redirect redirectUrl={route.meta.redirectUrl} />}
                />
              );
            }

            return (
              <Route
                key={route.path}
                path={route.path}
                element={
                  <route.component redirectUrl={route.meta.redirectUrl} />
                }
              />
            );
          })}
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
};

export default Router;
